module.exports = __webpack_public_path__ + "img/_01.59ea6679.png";